module.exports = "<span class=inp-subtle><span class=inp-subtle-span v-text=model||placeholder></span> <input class=inp-big-focus type=text v-model=model :placeholder=placeholder></span>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputSubtle.vue
 ** module id = 137
 ** module chunks = 0
 **/